/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelDataEntry = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ForecastModelDataEntry model module.
   * @module model/ForecastModelDataEntry
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForecastModelDataEntry</code>.
   * @alias module:model/ForecastModelDataEntry
   * @class
   */
  var exports = function() {
    var _this = this;






















  };

  /**
   * Constructs a <code>ForecastModelDataEntry</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForecastModelDataEntry} obj Optional instance to populate.
   * @return {module:model/ForecastModelDataEntry} The populated <code>ForecastModelDataEntry</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('LevelID')) {
        obj['LevelID'] = ApiClient.convertToType(data['LevelID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('IndicatorGroupID')) {
        obj['IndicatorGroupID'] = ApiClient.convertToType(data['IndicatorGroupID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomIndicatorIDs')) {
        obj['CustomIndicatorIDs'] = ApiClient.convertToType(data['CustomIndicatorIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ResponsibleUserID')) {
        obj['ResponsibleUserID'] = ApiClient.convertToType(data['ResponsibleUserID'], 'Integer');
      }
      if (data.hasOwnProperty('IsPrivate')) {
        obj['IsPrivate'] = ApiClient.convertToType(data['IsPrivate'], 'Boolean');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ManagerNote')) {
        obj['ManagerNote'] = ApiClient.convertToType(data['ManagerNote'], 'String');
      }
      if (data.hasOwnProperty('ResponsibleUserNote')) {
        obj['ResponsibleUserNote'] = ApiClient.convertToType(data['ResponsibleUserNote'], 'String');
      }
      if (data.hasOwnProperty('LastReminderSent')) {
        obj['LastReminderSent'] = ApiClient.convertToType(data['LastReminderSent'], 'Date');
      }
      if (data.hasOwnProperty('LastUpdate')) {
        obj['LastUpdate'] = ApiClient.convertToType(data['LastUpdate'], 'Date');
      }
      if (data.hasOwnProperty('LastError')) {
        obj['LastError'] = ApiClient.convertToType(data['LastError'], 'Date');
      }
      if (data.hasOwnProperty('LastErrorMessage')) {
        obj['LastErrorMessage'] = ApiClient.convertToType(data['LastErrorMessage'], 'String');
      }
      if (data.hasOwnProperty('GoogleConfigurationID')) {
        obj['GoogleConfigurationID'] = ApiClient.convertToType(data['GoogleConfigurationID'], 'Integer');
      }
      if (data.hasOwnProperty('SheetName')) {
        obj['SheetName'] = ApiClient.convertToType(data['SheetName'], 'String');
      }
      if (data.hasOwnProperty('StatusSheetColumn')) {
        obj['StatusSheetColumn'] = ApiClient.convertToType(data['StatusSheetColumn'], 'String');
      }
      if (data.hasOwnProperty('ManagerNoteSheetColumn')) {
        obj['ManagerNoteSheetColumn'] = ApiClient.convertToType(data['ManagerNoteSheetColumn'], 'String');
      }
      if (data.hasOwnProperty('ResponsibleUserNoteSheetColumn')) {
        obj['ResponsibleUserNoteSheetColumn'] = ApiClient.convertToType(data['ResponsibleUserNoteSheetColumn'], 'String');
      }
      if (data.hasOwnProperty('ExcelConfigurationID')) {
        obj['ExcelConfigurationID'] = ApiClient.convertToType(data['ExcelConfigurationID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} LevelID
   * @default 0
   */
  exports.prototype['LevelID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} IndicatorGroupID
   * @default 0
   */
  exports.prototype['IndicatorGroupID'] = 0;
  /**
   * @member {Array.<Integer>} CustomIndicatorIDs
   */
  exports.prototype['CustomIndicatorIDs'] = undefined;
  /**
   * @member {Integer} ResponsibleUserID
   * @default 0
   */
  exports.prototype['ResponsibleUserID'] = 0;
  /**
   * @member {Boolean} IsPrivate
   * @default false
   */
  exports.prototype['IsPrivate'] = false;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {String} ManagerNote
   * @default ''
   */
  exports.prototype['ManagerNote'] = '';
  /**
   * @member {String} ResponsibleUserNote
   * @default ''
   */
  exports.prototype['ResponsibleUserNote'] = '';
  /**
   * @member {Date} LastReminderSent
   */
  exports.prototype['LastReminderSent'] = undefined;
  /**
   * @member {Date} LastUpdate
   */
  exports.prototype['LastUpdate'] = undefined;
  /**
   * @member {Date} LastError
   */
  exports.prototype['LastError'] = undefined;
  /**
   * @member {String} LastErrorMessage
   * @default ''
   */
  exports.prototype['LastErrorMessage'] = '';
  /**
   * @member {Integer} GoogleConfigurationID
   */
  exports.prototype['GoogleConfigurationID'] = undefined;
  /**
   * @member {String} SheetName
   * @default ''
   */
  exports.prototype['SheetName'] = '';
  /**
   * @member {String} StatusSheetColumn
   * @default ''
   */
  exports.prototype['StatusSheetColumn'] = '';
  /**
   * @member {String} ManagerNoteSheetColumn
   * @default ''
   */
  exports.prototype['ManagerNoteSheetColumn'] = '';
  /**
   * @member {String} ResponsibleUserNoteSheetColumn
   * @default ''
   */
  exports.prototype['ResponsibleUserNoteSheetColumn'] = '';
  /**
   * @member {Integer} ExcelConfigurationID
   */
  exports.prototype['ExcelConfigurationID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


